import { Flex, Heading } from "@chakra-ui/react";
import { useState } from "react";
import { useLocation, Link } from "react-router-dom";
import styled from "styled-components";
import { useAppContext } from "../context/appContext/appContext";
import { FormInput, Logo, UIAlert } from "../components";

const ForgotPassword = () => {
  const { showAlert, forgotPassword, isLoading } = useAppContext();
  const location = useLocation();
  const [email, setEmail] = useState(location.state?.email || "");
  const [submitted, setSubmitted] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    const success = await forgotPassword(email);
    if (success) setSubmitted(true);
  };

  return (
    <Flex
      bgImage="url('ace.jpg')"
      bgPosition="center"
      bgRepeat="no-repeat"
      minH="100vh"
      justify="center"
      align="center"
    >
      <Wrapper>
        <form className="form" onSubmit={onSubmit}>
          <Logo
            image={"apple-touch-icon.png"}
            size={"50px"}
            color={"#63aab5"}
          />
          <Heading as="h2" size="lg" color="headline.400" fontStyle="italic">
            Forgot Password
          </Heading>
          {showAlert && <UIAlert />}
          {submitted ? (
            <p style={{ textAlign: "center" }}>
              If an account with that email exists, we've sent a link to
              reset your password. The link expires in 1 hour.
            </p>
          ) : (
            <>
              <p style={{ textAlign: "center" }}>
                Enter your account email and we'll send you a link to reset
                your password.
              </p>
              <FormInput
                inputType="input"
                name="email"
                value={email}
                labelText="Email"
                handleChange={(e) => setEmail(e.target.value)}
              />
              <button
                className="form-btn"
                bg="headline.400"
                color="white"
                disabled={isLoading}
              >
                Send Reset Link
              </button>
            </>
          )}
          <p>
            <Link to="/register" style={{ color: "#63aab5" }}>
              Back to Login
            </Link>
          </p>
        </form>
      </Wrapper>
    </Flex>
  );
};
export default ForgotPassword;

const Wrapper = styled.section`
  padding: 0 16px;
  box-sizing: border-box;

  .form {
    min-height: 400px;
    background-color: white;
    border: 3px solid #63aab5;
    margin: 0 auto;
    width: min(90vw, 500px);
    display: flex;
    box-sizing: border-box;
    align-items: center;
    border-radius: 5px;
    flex-direction: column;
    padding: clamp(16px, 5vw, 20px);
    gap: 20px;
    justify-content: center;
  }

  .form-btn {
    width: min(180px, 100%);
    margin: 5px;
    margin-top: 10px;
    cursor: pointer;
    border-radius: 5px;
    color: white;
    font-weight: bold;
    background-color: #63aab5;
    border: none;
    padding: 5px;
  }
`;
